import { useContext } from 'react';
import { PermissionsContext } from './PermissionsContext';

export default function usePermissions() {
  const { whiteList = [], userType = '', ready = true } = useContext(PermissionsContext);
  return {
    isAllowed:    (key) => whiteList.includes(key),
    isAdmin:      ()    => userType === 'admin',
    isManager:    ()    => ['admin', 'manager'].includes(userType),
    isBackoffice: ()    => ['admin', 'manager', 'backoffice'].includes(userType),
    isPorter:     ()    => ['admin', 'porter'].includes(userType),
    whiteList,
    userType,
    // False only while a signed-in user's permissions are still loading. Callers that
    // deny access on a miss should wait instead of denying (see ProtectedRoute);
    // callers that only show or hide a button can ignore it. Defaults to true so a
    // consumer rendered outside the provider behaves as it always did.
    ready,
  };
}
